import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  GetEmailsToSend,
  OrderInquiryModal,
  SendEMaill,
  SendEmailResModal,
  ViewOrdersSendEmail,
} from './send-email-modal.model';

@Injectable({
  providedIn: 'root',
})
export class SendEmailModalService {
  constructor(private httpClient: HttpClient) {}

  public getOrderEnquiryByOrderId(id: string) {
    const params = {
      orderId: id,
    };
    const url = 'SalesOrder/GetOrderEnquiryByOrderId';
    return this.httpClient.get<OrderInquiryModal>(url, { params: params });
  }

  public sendEmailToRep(data: SendEMaill) {
    const url = 'SalesOrder/Email';
    return this.httpClient.post<SendEmailResModal>(url, data);
  }

  public getEmailsToSend(id: string) {
    const params = { orderId: id };
    const url = 'SalesOrder/GetEmailsToSendViewOrder';
    return this.httpClient.get<GetEmailsToSend>(url, { params: params });
  }

  public viewOrderSendEmail(data: ViewOrdersSendEmail) {
    const url = 'SalesOrder/ViewOrderSendEmail';
    return this.httpClient.post<any>(url, data);
  }
}
